import { render, staticRenderFns } from "./DocumentChooserItem.vue?vue&type=template&id=4c05de8a&scoped=true&"
import script from "./DocumentChooserItem.vue?vue&type=script&lang=ts&"
export * from "./DocumentChooserItem.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentChooserItem.vue?vue&type=style&index=0&id=4c05de8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c05de8a",
  null
  
)

export default component.exports